module.exports = __webpack_public_path__ + "static/media/Dewott_gaussian2.230a2e77.png";